import { render } from "./DeleteRuleConfirmModalContent.vue?vue&type=template&id=3ea8c21e"
import script from "./DeleteRuleConfirmModalContent.vue?vue&type=script&lang=js"
export * from "./DeleteRuleConfirmModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/DeleteRuleConfirmModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ea8c21e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ea8c21e', __exports__)) {
    api.reload('3ea8c21e', __exports__)
  }
  
  module.hot.accept("./DeleteRuleConfirmModalContent.vue?vue&type=template&id=3ea8c21e", () => {
    api.rerender('3ea8c21e', render)
  })

}


export default __exports__